import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import {
  EVENT_CATEGORY_FOR_USER_FLOW,
  VALUE_FOR_USER_FLOW,
  PROPERTY_FOR_USER_FLOW,
  EVENT_NAME_FOR_USER_FLOW,
} from '../../../../../shop/constants/tracker';
import trackerService from '../../../../../service/trackerService';
import { PANEL } from '../../../constants/panel';
import { Google } from '../../../../context/Chakra/Icons';
import { delayRedirect } from '../../../../../utils/redirect';

const GOOGLE_OAUTH_URL = '/users/auth/google_oauth2';

const Container = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
`;

export function getLinkUrl(currentPanel) {
  const params = new URLSearchParams();

  if (currentPanel === PANEL.SIGN_UP) {
    params.set('signup', true);
  }

  const stringifyParams = params.toString();
  return stringifyParams.length > 0
    ? `${GOOGLE_OAUTH_URL}?${stringifyParams}`
    : GOOGLE_OAUTH_URL;
}

const GoogleAccountButton = ({ currentPanel, e2eId, isButtonStyle }) => {
  const link = useMemo(() => getLinkUrl(currentPanel), [currentPanel]);

  const handleClick = () => {
    if (currentPanel === PANEL.SIGN_UP) {
      trackerService.track({
        type: EVENT_NAME_FOR_USER_FLOW.ThirdPartySignUpClick,
        data: {
          event_category: EVENT_CATEGORY_FOR_USER_FLOW.SignUp,
          property: PROPERTY_FOR_USER_FLOW.sign_up_option,
          value: VALUE_FOR_USER_FLOW.google,
        },
      });
    } else if (currentPanel === PANEL.LOGIN) {
      trackerService.track({
        type: EVENT_NAME_FOR_USER_FLOW.ThirdPartyLoginClick,
        data: {
          event_category: EVENT_CATEGORY_FOR_USER_FLOW.MemberLogin,
          property: PROPERTY_FOR_USER_FLOW.login_option,
          value: VALUE_FOR_USER_FLOW.google,
        },
      });
    }

    delayRedirect(link);
  };

  return isButtonStyle ? (
    <Box
      flex={1}
      border="1px solid #e7e7e7"
      borderRadius="4px"
      padding="12px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      onClick={handleClick}
    >
      <Google boxSize="20px" mr="8px" />
      <Box fontSize="12px" fontWeight={600} lineHeight="20px">
        Google
      </Box>
    </Box>
  ) : (
    <IconButton aria-label="facebook login" variant="plain">
      <Container>
        <Google data-e2e-id={e2eId} boxSize="40px" onClick={handleClick} />
      </Container>
    </IconButton>
  );
};

GoogleAccountButton.propTypes = {
  currentPanel: PropTypes.oneOf([PANEL.LOGIN, PANEL.SIGN_UP]).isRequired,
  e2eId: PropTypes.string,
  isButtonStyle: PropTypes.bool,
};

export default GoogleAccountButton;
